import React, { useEffect } from 'react';
import pt from 'prop-types';

import { slugify } from 'utils';

import { FieldLocalized } from 'components/form';

import withWidget from './with-widget';
import withLocale from './with-locale';

const DEBOUNCE_DELAY = 700;

function SwellText(props) {
  const { value, localeValue, field, localized, onChange } = props;
  const { prop, label, description, defaultValue, params } = field;
  const { slugify: shouldSlugify } = params || {};

  // Debounce slugify
  useEffect(() => {
    if (!shouldSlugify) {
      return;
    }

    let timeout = setTimeout(() => {
      timeout = 0;
      onChange(null, slugify(value));
    }, DEBOUNCE_DELAY);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [value, shouldSlugify, onChange]);

  return (
    <FieldLocalized
      type="text"
      name={prop}
      label={label}
      value={value}
      defaultValue={defaultValue}
      localeValue={localeValue}
      onChange={onChange}
      hint={description}
      localized={localized}
      tooltipAlign="end"
      hintOnLast
      debounce={DEBOUNCE_DELAY}
    />
  );
}

SwellText.propTypes = {
  value: pt.string,
  localeValue: pt.object,
  field: pt.object,
  localized: pt.bool,
  onChange: pt.func,
};

export default withWidget(withLocale(SwellText));
